// Collapsing a picked file list for display.
//
// A CT series is hundreds of instances, so the upload field cannot show one row
// per file. These helpers group a selection into one row per archive or per exam
// folder, using the folder name from webkitRelativePath when the pick came from
// a directory.

import { isZipName } from "./dicomFilenames";

export const rawFile = (entry) => entry?.originFileObj || entry;

export const formatBytes = (n = 0) => {
  if (n >= 1e9) return `${(n / 1e9).toFixed(1)} Go`;
  if (n >= 1e6) return `${Math.round(n / 1e6)} Mo`;
  return `${Math.max(1, Math.round(n / 1e3))} ko`;
};

/**
 * @param {Array} fileList - antd form value: File objects (or {originFileObj}).
 * @returns {Array<{key,label,isFolder,count,size,entries}>} one entry per group.
 */
export function groupPicks(fileList = []) {
  const groups = new Map();

  fileList.forEach((entry) => {
    const file = rawFile(entry);
    if (!file || !file.name) return;

    const relPath = file.webkitRelativePath || "";
    let key;
    let label;
    let isFolder = false;

    if (isZipName(file.name)) {
      // Archives stay individual — each is one series/exam the user chose.
      key = `zip:${file.name}:${file.size}`;
      label = file.name;
    } else if (relPath.includes("/")) {
      isFolder = true;
      label = relPath.split("/")[0];
      key = `dir:${label}`;
    } else {
      key = "loose";
      label = "Fichiers DICOM";
    }

    const group = groups.get(key) || {
      key,
      label,
      isFolder,
      count: 0,
      size: 0,
      entries: [],
    };
    group.count += 1;
    group.size += file.size || 0;
    group.entries.push(entry);
    groups.set(key, group);
  });

  return Array.from(groups.values());
}

export const describeGroup = (group) =>
  `${group.count === 1 ? "1 fichier" : `${group.count} fichiers`} · ${formatBytes(group.size)}`;
